(ns shared.core.components.checkbox
  (:require [shared.core.components.icon :as icon]
            [shared.core.style :as style]
            [shared.core.reactive :as re]
            [shared.core.components.theme :as theme]))

(defn checkbox [{:keys [id form-path form-name val-subscribe disabled? checked? on-click container-style style
                        content-style content-responsive-style disabled-style on-label-click label extra-on-click
                        checked-style]}
                & contents]
  (let [contents (or contents (when label [label]))
        checked?- (if val-subscribe
                    (re/subscribe val-subscribe)
                    (when (and form-path form-name)
                      (re/subscribe [:form/val- form-path form-name])))
        check-click (when-not disabled?
                      #(do
                        (if on-click
                          (on-click %)
                          (when (and form-path form-name)
                            (re/dispatch [:form/change
                                          form-path
                                          form-name
                                          (not (or checked? (and checked?- @checked?-)))])))
                        (when extra-on-click
                          (extra-on-click %))))
        check-style (merge {:color (style/color :green :base)
                            :font-size 25
                            :cursor :pointer
                            :flex "0 0 auto"
                            :margin-right 5
                            :position :relative}
                           (when disabled?
                             {:cursor :not-allowed
                              :opacity 0.5})
                           (when disabled?
                             disabled-style)
                           style
                           (when (or checked? (and checked?- @checked?-))
                             checked-style))]
    [:div {:id id
           :style (merge {:display :flex
                          :align-items :center}
                         container-style)}
     [:input {:type :checkbox
              :style {:opacity 0
                      :margin 0
                      :height 0
                      :width 0}}]
     [theme/theme
      :div {:style (assoc check-style :height (:font-size check-style))
            :theme (style/dark-style {:color (style/dark-color :primary :base)})
            :on-click check-click}
      [:div {:style {:background-color (style/color :white :base)
                     :border-radius 3
                     :position :absolute
                     :top 3
                     :left 3
                     :height "calc(100% - 6px)"
                     :width "calc(100% - 6px)"}}]
      [theme/theme
       icon/material-icon {:icon-type (if (or checked? (and checked?- @checked?-))
                                        :check_box
                                        :check_box_outline_blank)
                           :style (cond-> {:color (:color check-style)
                                           :font-size (:font-size check-style)
                                           :position :relative
                                           :z-index (style/z :low)}
                                          (and (or checked? (and checked?- @checked?-)) checked-style)
                                          (merge checked-style))
                           :theme (style/dark-style {:color (style/dark-color :primary :base)})}]]
     (when contents
       (into [:div {:style (merge {:color (style/colors :gray :base)
                                   :font-size 16
                                   :line-height 1.3
                                   :cursor :pointer
                                   :flex "0 0 auto"
                                   :max-width "100%"}
                                  (when disabled?
                                    {:cursor :not-allowed
                                     :opacity 0.5})
                                  content-style)
                    :responsive {:style (merge {:font-size 15}
                                               content-responsive-style)}
                    :on-click (or on-label-click check-click)}]
             contents))]))

(defn small-checkbox [{:keys [style] :as args}
                      & contents]
  (into [checkbox (merge args
                         {:style (merge {:font-size 18}
                                        style)})]
        contents))

(defn checkbox-group [{:keys [form-path form-name label options disabled? container-style]}]
  (let [selected-values- (when (and form-path form-name)
                          (re/subscribe [:form/val- form-path form-name]))
        selected-values (or @selected-values- #{})]
    [:div {:style container-style}
     (when label
       [:div {:style {:color (style/color :gray :base)
                      :font-size 14
                      :font-weight style/font-medium-weight
                      :margin-bottom 5}}
        label])
     (into [:div {:style {:display :flex
                          :flex-direction :column}}]
           (map (fn [{:keys [text value]}]
                  (let [checked? (contains? (set selected-values) value)]
                    [checkbox {:checked? checked?
                               :disabled? disabled?
                               :label text
                               :container-style {:margin-bottom 5}
                               :on-click (fn []
                                          (let [new-values (if checked?
                                                            (disj (set selected-values) value)
                                                            (conj (set selected-values) value))]
                                            (re/dispatch [:form/change form-path form-name (vec new-values)])))}]))
                options))]))
